import React, { FC } from 'react';
import { ReportValue } from '../../Models';

export type IntegrationReportsContextState = {
  integrationReports: ReportValue[];
  setIntegrationReports: React.Dispatch<React.SetStateAction<ReportValue[]>>;
};

const contextDefaultValues: IntegrationReportsContextState = {
  integrationReports: [],
  setIntegrationReports: () => {}
};

export const IntegrationReportsContext =
  React.createContext<IntegrationReportsContextState>(contextDefaultValues);

export const IntegrationReportsProvider: FC = ({ children }) => {
  const [integrationReports, setIntegrationReports] = React.useState<
    ReportValue[]
  >([]);

  return (
    <IntegrationReportsContext.Provider
      value={{
        integrationReports,
        setIntegrationReports
      }}
    >
      {children}
    </IntegrationReportsContext.Provider>
  );
};
